import type { InputDataT } from '../../labelling/types/studio-interface.type';
import type { LabelStateT } from '../../labelling/types/types';
export function getIsVideoTask(inputData: InputDataT, initialState: LabelStateT): boolean {
  const hasVideoUrl = ('videoUrl' in inputData);
  const hasPdfUrl = ('pdfUrl' in inputData);
  const hasFrames = initialState.frames.length > 1;
  return hasVideoUrl || hasFrames && !hasPdfUrl;
}